import React from 'react';

export default function StatsLoader() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 animate-pulse">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="h-32 bg-gray-100 rounded-lg"></div>
      ))}
    </div>
  );
}